import { flex } from "@styled-system/patterns";

export const pointsWrapper = flex({
	w: "[fit-content]",
});
